import React, { FC } from 'react';
import { Route } from 'react-router';

import StandModelsTable from '../components/equipments-stand-models-guide/table';
import StandModelEdit from '../components/equipments-stand-models-guide/edit';

const EquipmentsStandModelsGuidePage: FC = () => {
  return (
    <>
      <Route
        exact
        path="/equipments-stand-model-guide/edit/:id"
        component={StandModelEdit}
      />
      <Route
        exact
        path="/equipments-stand-model-guide"
        component={StandModelsTable}
      />
    </>
  );
};

export default EquipmentsStandModelsGuidePage;
